import * as defaultImport from "@splunk/react-icons/SquaresLayeredPlus";
export * from "@splunk/react-icons/SquaresLayeredPlus";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
